<template>
  <div
    id="app"
    class="wsk-root wsk-app ws-fields-arrangement"
    :class="'theme--' + conf.theme"
  >
    <layout-default />
    <ws-outdated-modal />
    <theme-switcher v-if="$store.state.devUtils" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import config from './services/config.service';
import LayoutDefault from './views/LayoutDefault.vue';


export default defineComponent({
  components: {
    LayoutDefault,
  },
  setup() {
    return {conf: config};
  }
});
</script>

<style lang="scss" scoped>
.wsk-root.wsk-app {
  background-color: $body-bg;

  .build-number {
    position: fixed;
    z-index: 10000;
    bottom: 0;
    left: 0;
    font-size: 8px;
    line-height: 8px;
    color: red;
    padding: 4px;
  }
}
</style>
